<template>
  <div class="footBar">
    <div class="moreFootView flex_g between">
      <div class="moreFootItem">
        <div class="footCaption">{{ $t("foot.doc.title") }}</div>
        <div
          class="footMoreContent footMoreHover"
          @click="
            jumpToPage(
              'https://github.com/starry-graph/FanXingFund-TemporalGraph',
              JumpActions.OPENS_AT_NEW_WINDOW
            )
          "
        >
          {{ $t("foot.doc.item1") }}
        </div>
        <div
          class="footMoreContent footMoreHover"
          @click="jumpToPage('/dataSet')"
        >
          {{ $t("foot.doc.item2") }}
        </div>
      </div>
      <div class="moreFootItem">
        <div class="footCaption">{{ $t("foot.contact.title") }}</div>
        <!--<div class="footMoreContent">021-55698603</div>-->
        <div class="footMoreContent">starrygraph@zju.edu.cn</div>
      </div>
      <div class="moreFootItem">
        <img class="mainLogo" src="@/assets/images/logo_white.png" />
      </div>
    </div>
    <div class="footTip">
      <p>© 2004-2024 {{ $t("foot.un") }}</p>
      <!--<p>-->
        <!--<a-->
          <!--target="_blank"-->
          <!--href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502019924"-->
          <!--style="-->
            <!--display: inline-block;-->
            <!--text-decoration: none;-->
            <!--height: 20px;-->
            <!--line-height: 20px;-->
          <!--"-->
        <!--&gt;-->
          <!--<img src="@/assets/images/beian.png" style="float: left" />-->
          <!--<font color="#ffffff">{{ $t("foot.no1") }}</font></a-->
        <!--&gt;-->
        <!--{{ $t("foot.no2") }}-->
      <!--</p>-->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // Constants
      JumpActions: {
        PUSHES_TO_ROUTER: 1,
        OPENS_AT_NEW_WINDOW: 2,
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    jumpToPage(url, action) {
      // Default action
      if (!action) {
        action = this.JumpActions.PUSHES_TO_ROUTER;
      }
      if (action == this.JumpActions.PUSHES_TO_ROUTER) {
        this.$router.push({
          path: url,
        });
      } else {
        window.open(url, "_blank");
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.footBar {
  background: #26292e;
  padding: 2rem 18%;
  position: relative;
  z-index: 15;

  .moreFootView {
    margin-bottom: 2rem;

    .moreFootItem {
      .footCaption {
        margin-bottom: 0.8rem;
        font-size: 1.4rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 1.5rem;
      }

      .footMoreContent {
        font-size: 1.2rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 2rem;
        opacity: 0.4;
      }

      .footMoreHover:hover {
        opacity: 1;
        cursor: default;
      }

      .mainLogo {
        width: 10rem;
        height: 3rem;
        margin-bottom: 2rem;
        display: block;
      }
    }
  }

  .footTip {
    text-align: center;
    font-size: 1.2rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 1.83rem;
    opacity: 0.4;
  }
}

@media (min-width: 1450px) {
  .footBar {
    padding: 30px 18%;

    .moreFootView {
      margin-bottom: 30px;

      .moreFootItem {
        .footCaption {
          margin-bottom: 8px;
          font-size: 18px;
          line-height: 20px;
        }

        .footMoreContent {
          font-size: 14px;
          line-height: 22px;
        }

        .mainLogo {
          width: 110px;
          height: 30px;
          margin-bottom: 18px;
        }
      }
    }

    .footTip {
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>
